<template>
  <div class="message-layout" :class="{'pending-moderation': pendingModeration}">
    <div v-if="pendingModeration" class="mb10">
      {{ i18n.t('member.forums.message_awaiting_moderation') }}
    </div>
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    pendingModeration: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
  .message-layout {
    display: flex;
    flex-direction: column;
    padding: 10px;
  }

  .pending-moderation {
    background-color: #C0C0C0
  }
</style>

